import { FC } from "react";
import Svg, { Path } from "react-native-svg";

interface FolderSharedProps {
  color?: string;
  size?: number;
}

/**
 * Material Icons `folder_shared` (baseline).
 * Source: https://github.com/google/material-design-icons
 * (src/file/folder_shared/materialicons/24px.svg)
 */
const FolderShared: FC<FolderSharedProps> = ({
  color = "currentColor",
  size = 24,
}) => (
  <Svg fill={color} height={size} viewBox="0 0 24 24" width={size}>
    <Path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z" />
  </Svg>
);

export default FolderShared;
